import createIcon from '../../createIcon';

/**
 * @component @name PanoramaHorizontalSelect
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNDMgNEMyMS4zMyA0IDIxLjIzIDQuMDIgMjEuMTIgNC4wNkMxOC4xOCA1LjE2IDE1LjA5IDUuNyAxMiA1LjdDOC45MSA1LjcgNS44MiA1LjE1IDIuODggNC4wNkMyLjc3IDQuMDIgMi42NiA0IDIuNTcgNEMyLjIzIDQgMiA0LjIzIDIgNC42M1YxOS4zOEMyIDE5Ljc3IDIuMjMgMjAgMi41NyAyMEMyLjY3IDIwIDIuNzcgMTkuOTggMi44OCAxOS45NEM1LjgyIDE4Ljg0IDguOTEgMTguMyAxMiAxOC4zQzE1LjA5IDE4LjMgMTguMTggMTguODUgMjEuMTIgMTkuOTRDMjEuMjMgMTkuOTggMjEuMzMgMjAgMjEuNDMgMjBDMjEuNzYgMjAgMjIgMTkuNzcgMjIgMTkuMzdWNC42M0MyMiA0LjIzIDIxLjc2IDQgMjEuNDMgNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PanoramaHorizontalSelect = createIcon('PanoramaHorizontalSelect', [
  [
    'path',
    {
      d: 'M21.43 4C21.33 4 21.23 4.02 21.12 4.06C18.18 5.16 15.09 5.7 12 5.7C8.91 5.7 5.82 5.15 2.88 4.06C2.77 4.02 2.66 4 2.57 4C2.23 4 2 4.23 2 4.63V19.38C2 19.77 2.23 20 2.57 20C2.67 20 2.77 19.98 2.88 19.94C5.82 18.84 8.91 18.3 12 18.3C15.09 18.3 18.18 18.85 21.12 19.94C21.23 19.98 21.33 20 21.43 20C21.76 20 22 19.77 22 19.37V4.63C22 4.23 21.76 4 21.43 4Z',
      key: '5gn9rf',
    },
  ],
]);

export default PanoramaHorizontalSelect;
